import { render, staticRenderFns } from "./dataAnalysis.vue?vue&type=template&id=42b22d3d&"
import script from "./dataAnalysis.vue?vue&type=script&lang=js&"
export * from "./dataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalysis.vue?vue&type=style&index=0&id=42b22d3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports